import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import axios from "axios";
import dayjs from "dayjs";
import { Result } from "antd";
import { EmployeeSalaries } from "../Finance/components/EmployeeSalaries";
import { PeriodSelector } from "../Finance/components/PeriodSelector";
import { usePermissions } from "../../utils/usePermissions";
import { isSuperAdmin } from "../../utils/permissions";
import { BASE_API_URL } from "../../utils/consts";
import { isLocationVisibleForPeriod } from "../../utils/helpers/locationVisibility";
import "../Finance/Finance.scss";

const Salaries: React.FC = () => {
  const { t } = useTranslation();
  const userData = useSelector((state: any) => state.userData.user);
  const rawClientId = userData?.clientId;
  const clientId =
    typeof rawClientId === "object" ? rawClientId?._id : rawClientId;

  const { hasPermission } = usePermissions();
  const canView =
    isSuperAdmin(userData?.roles) || hasPermission("salaries:view");

  const [selectedMonths, setSelectedMonths] = useState<string[]>([
    dayjs().format("YYYY-MM"),
  ]);
  const [locations, setLocations] = useState<any[]>([]);

  useEffect(() => {
    if (!clientId) return;
    axios
      .get(`${BASE_API_URL}/${clientId}/locations`)
      .then((res) => setLocations(res.data || []))
      .catch(() => {});
  }, [clientId]);

  const availableLocations = useMemo(
    () => locations.filter((loc: any) => isLocationVisibleForPeriod(loc, selectedMonths)),
    [locations, selectedMonths],
  );

  if (!canView) {
    return (
      <Result
        status="403"
        title="403"
        subTitle={t("You don't have permission to view this page.")}
      />
    );
  }

  return (
    <div className="finance-page" style={{ padding: "24px 24px 0" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 24,
          flexWrap: "wrap",
          gap: 12,
        }}
      >
        <h1
          style={{
            margin: 0,
            fontSize: 20,
            fontWeight: 700,
            color: "#111827",
          }}
        >
          {t("Employee Salaries")}
        </h1>
        <PeriodSelector
          selectedMonths={selectedMonths}
          onMonthsChange={setSelectedMonths}
        />
      </div>

      {clientId && (
        <EmployeeSalaries
          clientId={clientId}
          selectedMonths={selectedMonths}
          availableLocations={availableLocations}
          locationFilters={[]}
          sectorFilters={[]}
        />
      )}
    </div>
  );
};

export default Salaries;
